import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { credentialsFeatureKey, reducer } from './credentials.reducer';
import { CredentialsEffects } from './credentials.effects';
import { CredentialsFacade } from '@web/store/credentials/credentials.facade';

@NgModule({
    declarations: [],
    imports: [StoreModule.forFeature(credentialsFeatureKey, reducer), EffectsModule.forFeature([CredentialsEffects])],
    providers: [CredentialsFacade],
})
export class CredentialsStoreModule {}
